import Helpers from '../modules/Helpers'

const body = document.querySelector('body')
const header = document.getElementById('header')
const mobileNavigationIcon = document.getElementById('mobileNavIcon')
const megaMenus = document.getElementsByClassName('megamenu')
const megaMenuToggles = document.getElementsByClassName('megamenu-toggle')
const ownerNavTaggles = document.getElementsByClassName('owners-navigation__toggles')
const ownerNavMenu = document.getElementsByClassName('owners-navigation__options')

// Open and close mobile navigation when clicking mobile menu icon
new Helpers(mobileNavigationIcon).eventListener((e) => {
    e.preventDefault()

    new Helpers(mobileNavigationIcon).toggleClass('burger-icon--active')
    new Helpers(header).toggleAttribute('aria-expanded')

    new Helpers(body)
        .toggleClass('mobile-nav--active')
        .removeClass('megamenu--expanded')

    new Helpers(megaMenus).removeClass('megamenu--active')
    new Helpers(megaMenuToggles).removeClass('megamenu-toggle--active')
})

new Helpers(ownerNavTaggles).eventListener((e) => {
    e.preventDefault()

    new Helpers(ownerNavMenu).toggleClass('owners-navigation__options--active')
})

